import { Stack } from 'ui';

import { formatSampleValue } from '../../utils/formatSampleValue/formatSampleValue';
import { MaterialBreakdownItem } from '../MaterialBreakdownItem/MaterialBreakdownItem';
import type { Item } from '../MaterialSampleBreakdown/MaterialSampleBreakdown';

export const PetFlakeMaterialSampleBreakdown = ({
  breakdown,
  precision = 1,
}: {
  breakdown: Record<string, Item>;
  precision?: number;
}) => {
  const renderField = (fieldname: string) => {
    return (
      <MaterialBreakdownItem
        key={fieldname}
        label={fieldname}
        value={breakdown[fieldname] ? formatSampleValue(breakdown[fieldname], precision) : '-'}
      />
    );
  };

  return (
    <Stack gap={2}>
      {renderField('Sampled by')}
      {renderField('Intrinsic viscosity')}
      {renderField('Clear flakes')}
      {renderField('Light blue flakes')}
      {renderField('Dark blue flakes')}
      {renderField('Polyethylene terephthalate (PET) content')}
      {renderField('PVC contamination')}
      {renderField('Polyolefin contamination')}
      {renderField('Residual contamination')}
      {renderField('Glue')}
      {renderField('Residual moisture')}
      {renderField('Particles with size < 5 mm')}
      {renderField('Particles with size between 5 and 10 mm')}
      {renderField('Particles with size between 10 and 12 mm')}
      {renderField('Bulk density')}
      {renderField('Yellow flakes')}
      {renderField('Green flakes')}
      {renderField('Coloured flakes')}
      {renderField('Ferrous metal')}
      {renderField('Non-ferrous metal')}
      {renderField('Paper')}
      {renderField('Wooden materials')}
      {renderField('Other impurities')}
      {renderField('pH')}
      {renderField('Isophthalic acid')}
      {renderField('Melt flow rate (MF) index (260°C/2,16Kg)')}
      {renderField('Melting point')}
    </Stack>
  );
};
